import { render, staticRenderFns } from "./InvestmentReviewReport.vue?vue&type=template&id=c9089c78&scoped=true"
import script from "./InvestmentReviewReport.vue?vue&type=script&lang=js"
export * from "./InvestmentReviewReport.vue?vue&type=script&lang=js"
import style0 from "./InvestmentReviewReport.vue?vue&type=style&index=0&id=c9089c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9089c78",
  null
  
)

export default component.exports